import React from 'react'
import { useTranslation } from 'lib/i18n'
import Image from 'next/image'

import Link from 'components/Link/Link'
import { Box } from 'components/UI/Box/Box'
import { Button } from 'components/UI/Button/Button'
import {
  BodyText,
  DesktopH2,
  H3,
  H5,
} from 'components/UI/Typography/Typography.new'

import IconGreet from './icon-greet.svg'
import IconMkt from './icon-mkt.svg'
import IconParty from './icon-party.svg'

import styles from './BusinessPageIdeas.module.css'

const BusinessPageIdeas = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper} data-cy="businessPageIdeas">
      <div className={styles.title}>
        <DesktopH2 element="h2">
          {t('BusinessPageIdeas.title', 'Videos for all your needs')}
        </DesktopH2>
      </div>
      <H5 element="h3">
        {t(
          'BusinessPageIdeas.subtitle1',
          'Here are some ways our clients have used memmo',
        )}
      </H5>

      <div className={styles.ideas}>
        <Box hideFooter className={styles.ideaBox}>
          <div className={styles.ideaIcon}>
            <Image src={IconMkt} width={43} height={43} alt="Marketing" />
          </div>
          <div className={styles.ideaContent}>
            <H3 strict element="h3">
              {t('BusinessPageIdeas.marketing', 'Marketing')}
            </H3>
            <BodyText>
              {t(
                'BusinessPageIdeas.marketingText',
                'Boost your marketing with celebrity videos specifically made for your business.',
              )}
            </BodyText>
          </div>
        </Box>

        <Box hideFooter className={styles.ideaBox}>
          <div className={styles.ideaIcon}>
            <Image src={IconGreet} width={43} height={43} alt="Greeting" />
          </div>
          <div className={styles.ideaContent}>
            <H3 strict element="h3">
              {t('BusinessPageIdeas.greet', 'Greet your colleagues')}
            </H3>
            <BodyText>
              {t(
                'BusinessPageIdeas.greetText1',
                'A video greeting from a celebrity to your colleagues always boosts the team spirit!',
              )}
            </BodyText>
          </div>
        </Box>

        <Box hideFooter className={styles.ideaBox}>
          <div className={styles.ideaIcon}>
            <Image src={IconParty} width={43} height={43} alt="Party" />
          </div>
          <div className={styles.ideaContent}>
            <H3 strict element="h3">
              {t('BusinessPageIdeas.party', 'Corporate Party')}
            </H3>
            <BodyText>
              {t(
                'BusinessPageIdeas.partyText1',
                'Let a celebrity join your party either live via zoom or in a personalised message!',
              )}
            </BodyText>
          </div>
        </Box>
      </div>
      <div className={styles.ideasCta}>
        <H5>
          <div className={styles.ideasCtaText1}>
            {t(
              'BusinessPageIdeas.ideasCtaText1',
              'Looking for something else?',
            )}
          </div>
          <div className={styles.ideasCtaText2}>
            {t('BusinessPageIdeas.ideasCtaText2', 'Let us help you!')}
          </div>
        </H5>
      </div>

      <Link href="/page/business-form">
        <a data-cy="businessPageStatsCta">
          <Button
            onClick={() => null}
            className={styles.findTalentButton}
            type="blue"
          >
            {t('BusinessPageIdeas.cta', 'Contact our team')}
          </Button>
        </a>
      </Link>
    </div>
  )
}

export default BusinessPageIdeas
